import { axios, getUserTokenLocalStorage } from '../helpers';

// keep axios syntax for simplicity
export const authFetch = {
  get: async (url: string, params?: any, options?: any) => {
    const accessToken = await getUserTokenLocalStorage();

    return await axios.get(url, {
      ...options,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }, params);
  },
  getFile: async (url: string, options?: any) => {
    const accessToken = await getUserTokenLocalStorage();

    // Destructure headers from options to merge them properly
    const { headers: optionHeaders, ...restOptions } = options || {};

    const headers = {
      Authorization: `Bearer ${accessToken}`,
      ...optionHeaders,
    };

    const config = { ...restOptions, headers };

    return await axios.get(url, config);
  },
  put: async (url: string, data: any, options?: any) => {
    const routeOptions = {
      ...options,
      ...{
        headers: {
          Authorization: `Bearer ${await getUserTokenLocalStorage()}`,
        },
      },
    };
    return await axios.put(url, data, routeOptions);
  },
  post: async (url: string, data: any, options?: any) => {
    const routeOptions = {
      ...options,
      ...{
        headers: {
          Authorization: `Bearer ${await getUserTokenLocalStorage()}`,
        },
      },
    };

    return await axios.post(url, data, routeOptions);
  },
  delete: async (url: string) => {
    return await axios.delete(url, {
      headers: {
        Authorization: `Bearer ${await getUserTokenLocalStorage()}`,
      },
    });
  },
};
